


































import Vue from 'vue';

export default Vue.extend({
  name: 'ShowListItem',

  props: {
    title: {
      type: String,
      required: true,
    },

    duration: {
      type: String,
      required: true,
    },

    genres: {
      type: Array,
      required: true,
    },

    released: {
      type: String,
      required: true,
    },

    imageUrl: {
      type: String,
      required: true,
    },
  },

  methods: {
    clicked() {
      this.$router.push(`/show/${this.title}`);
    },
  },
});
